import React from 'react'
import { connect, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { isLoggedIn } from 'application/services/authenticationService'
import { useIdleTimer } from 'react-idle-timer'
import { theme } from 'Maxxia/theme'


const LogoutButton = () => {
  const IDLE_TIME_OUT = 1000 * 60 * 30 //30min

  let opportunity = useSelector((state) => state.opportunity)
  let opportunityId = opportunity && opportunity.opportunityId

  const handleOnIdle = (event) => {
    logoutHandler()
  }
  useIdleTimer({
    timeout: IDLE_TIME_OUT,
    onIdle: handleOnIdle,
    debounce: 500,
  })
  const logoutHandler = (e) => {
    e && e.preventDefault()
    window.location.href = '/logout/' + opportunityId
  }
  const linkColor = global.config.isBrandMX
    ? theme.colors.navColor
    : theme.colors.textDarkblack
  return isLoggedIn() ? (
    <Link style={{ color: linkColor }} onClick={logoutHandler} to={null}>
      Logout
    </Link>
  ) : null
}

export default connect()(LogoutButton)
